/**
 * Renders text input boxes for the provided variables with the supplied values. Calls onVarChange
 * with the name of the variable changed and the new value when a input changes.
 * @param vars
 * @param values
 * @param onVarChange
 * @returns {ReactElement}
 * @constructor
 */
import PropTypes from 'prop-types';
import React from 'react';
import { Box } from 'signoxe/components/layout';

const WebTemplateVariableView = ({vars, values, help, dataFile, onVarChange, onDataFileChange}) => {
  const handleVarChange = (varName) => (e) => onVarChange(varName, e.currentTarget.value);
  const handleFileSelect = (e) => {
    if (e.currentTarget.files && e.currentTarget.files[0]) {
      onDataFileChange(e.currentTarget.files[0]);
    }
  };

  return (
    <Box direction="column" className="vars-form">
      <div className="help"
           dangerouslySetInnerHTML={{__html: help}}/>
      {vars.map(varName => (
        <label key={varName}>
          {varName}
          <input id={varName}
                 type="text"
                 name={varName}
                 placeholder={varName}
                 value={values.hasOwnProperty(varName) ? values[varName] : ''}
                 onChange={handleVarChange(varName)}/>
        </label>
      ))}
      {dataFile &&
      <label htmlFor="dataFile">Data File
        <input type="file" name="dataFile" id="dataFile" onChange={handleFileSelect} accept=".csv"/>
      </label>}
    </Box>
  );
};

WebTemplateVariableView.propTypes = {
  vars: PropTypes.array.isRequired,
  values: PropTypes.object.isRequired,
  help: PropTypes.string.isRequired,
  onVarChange: PropTypes.func.isRequired,
  onDataFileChange: PropTypes.func.isRequired,
  dataFile: PropTypes.bool.isRequired,
};

export default WebTemplateVariableView;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/WebTemplateVariableView/index.js